import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { useMutation, useQuery } from '@apollo/client'
// import ReactGoogleAutocomplete from 'react-google-autocomplete'
import { SkyButton, SkyOutlinedButton } from '../../../Components/Buttons'
import CustomInput from '../../../Components/Input/CustomInput'
import DatePicker from '../../../Components/Input/DatePicker'
import {
  FIND_ALL_UNIQUE_CAR_BRANDS,
  FIND_CARS_BY_BRAND,
} from '../../../Services/cabggl'
import Select from '../../../Components/Autocompelte/Select'
import { UPDATE_FLEET_CAB } from '../../../Services/cabapi/fleetggl'
import { useLocation, useNavigate } from 'react-router-dom'
import StyledFileInput from '../../../Components/Input/Input'
import { updateFleetCabAndFiles } from '../../../Services/cabapi/fleetapi'

const FleetCabEdit = ({}) => {
  const navigate = useNavigate()
  const location = useLocation()
  const selectedCab = location?.state
  const [updateFleetCab, { data, loading }] = useMutation(UPDATE_FLEET_CAB)
  const [selectedBrand, setSelectedBrand] = useState([])
  const [carModels, setCarModels] = useState([])
  const [carOptions, setCarOptions] = useState([])
  const { data: dataBrands } = useQuery(FIND_ALL_UNIQUE_CAR_BRANDS)
  const [minDateCurrentDate, setMinDateCurrentDate] = useState('')
  const { data: modelData } = useQuery(FIND_CARS_BY_BRAND, {
    variables: { brand: selectedBrand?.value },
    skip: !selectedBrand,
  })
  useEffect(() => {
    if (dataBrands) {
      const formattedBrands = dataBrands.findAllUniqueBrands.map((brand) => ({
        label: brand,
        value: brand,
      }))
      setCarModels(formattedBrands)
    }
  }, [dataBrands])

  useEffect(() => {
    if (modelData) {
      const formattedOptions = modelData.findCarsByBrand.map((car) => ({
        label: `${car.brand} - ${car.variant}`,
        value: `${car.brand} - ${car.variant}`,
      }))
      setCarOptions(formattedOptions)
    }
  }, [modelData])
  useEffect(() => {
    const today = new Date()
    const formattedToday = today.toISOString().split('T')[0]
    setMinDateCurrentDate(formattedToday)
  }, [])
  const [carDetails, setCarDetails] = useState({
    id: selectedCab?._id,
    carOwnerName: selectedCab?.carOwnerName || '',
    carNo: selectedCab?.carNo || '',
    registrationDate: new Date(selectedCab?.registrationDate) || new Date(),
    registrationExpiryDate:
      new Date(selectedCab?.registrationExpiryDate) || new Date(),
    insuranceExpiryDate:
      new Date(selectedCab?.insuranceExpiryDate) || new Date(),
    permitExpiryDate: new Date(selectedCab?.permitExpiryDate) || '',
    pucExpiryDate: new Date(selectedCab?.pucExpiryDate) || '',
    color: selectedCab?.color,
    variant: selectedCab?.variant || '',
  })
  const [files, setFiles] = useState({
    rcBook: null,
    permit: null,
    puc: null,
    insurance: null,
  })

  const [errors, setErrors] = useState({})

  const handleInputChange = (name, value) => {
    setCarDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }))
  }
  const validateForm = () => {
    const newErrors = {}
    if (!carDetails.carOwnerName)
      newErrors.carOwnerName = 'Car Owner Name is required*'
    if (!carDetails.carNo) newErrors.carNo = 'Car Number is required*'
    const carNumberRegex = /^[A-Z]{2}[0-9]{2}[A-Z]{2}[0-9]{4}$/

    if (!carDetails.carNo) {
      newErrors.carNo = 'Car Number is required*'
    }
    if (!carNumberRegex.test(carDetails.carNo)) {
      newErrors.carNo = 'Enter valid car number'
    }
    if (!carDetails.registrationDate)
      newErrors.registrationDate = 'Registration Date is required*'
    if (!carDetails.registrationExpiryDate) {
      newErrors.registrationExpiryDate =
        'Registration Expiry Date is required *'
    } else {
      // Parse the registration dates
      const registrationDate = new Date(carDetails.registrationDate)
      const registrationExpiryDate = new Date(carDetails.registrationExpiryDate)
      const diffTime = registrationExpiryDate - registrationDate
      const diffDays = diffTime / (1000 * 3600 * 24) // Convert milliseconds to days
      const maxDiffDays = 5 * 365.25
      if (diffDays > maxDiffDays) {
        newErrors.registrationExpiryDate = 'Enter valid expiry date'
      }
      if (registrationExpiryDate < registrationDate) {
        newErrors.registrationExpiryDate = 'Enter valid expiry date'
      }
    }
    if (!carDetails.insuranceExpiryDate)
      newErrors.insuranceExpiryDate = 'Insurance Expiry Date is required*'
    if (!carDetails.permitExpiryDate)
      newErrors.permitExpiryDate = 'Permit Expiry Date is required*'
    if (!carDetails.pucExpiryDate)
      newErrors.pucExpiryDate = 'PUC Expiry Date is required*'
    if (!carDetails.color) newErrors.color = 'Color is required*'
    if (!carDetails.variant) newErrors.variant = 'Variant is required*'
    console.log('inside 2', newErrors)

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0 // Return true if no errors
  }
  const handleFileChange = (e) => {
    setFiles({ ...files, [e.target.name]: e.target.files[0] })
  }
  const handleSubmit = async () => {
    console.log('files', files)
    if (!validateForm()) {
      return
    }
    try {
      const data = new FormData()
      Object.entries(carDetails).forEach(([key, value]) => {
        data.append(key, value)
      })
      Object.entries(files).forEach(([key, file]) => {
        if (file) {
          data.append(key, file)
        }
      })
      await updateFleetCabAndFiles(data).then((res) => {
        toast.success('Cab details updated successfully')
        navigate('/manage-cabs')
      })
    } catch (error) {
      alert(error)
      toast.error('Failed to update cab details')
      console.log('error')
    }
  }

  return (
    <div className="flex justify-center w-full">
      <div className="bg-white w-full shadow-lg p-4 my-4 sm:w-[90%] xl:w-[100%]">
        <div className="flex flex-start">
          <SkyOutlinedButton label={'Back'} onClick={() => navigate(-1)} />
        </div>
        <h2 className="text-xl font-bold text-center">Update Cab</h2>
        <div className="mt-2">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-2 text-start">
            <div>
              <CustomInput
                placeholderValue={'Car Owner Name'}
                labelValue={'Car Owner Name'}
                required
                name={`carOwnerName`}
                value={carDetails?.carOwnerName || ''}
                onChange={(value) => handleInputChange('carOwnerName', value)}
                style={{
                  borderColor: errors.carOwnerName ? 'red' : '',
                }}
              />
              {errors.carOwnerName && (
                <small className="text-red-500">{errors.carOwnerName}</small>
              )}
            </div>
            <div>
              <div className="flex gap-1 w-full flex-col text-start max-w-96">
                <label className="text-stone-700 text-xs md:text-base font-semibold mt-2">
                  Rc Book
                </label>
                <StyledFileInput name={'rcBook'} onChange={handleFileChange} />
                {errors?.rcBook && (
                  <small className="text-red-500">{errors?.rcBook}</small>
                )}
              </div>
            </div>
            <div>
              <CustomInput
                placeholderValue={'Car Number'}
                labelValue={'Enter Car Number'}
                required
                formatCarNumber
                name={`carNo`}
                value={carDetails?.carNo || ''}
                onChange={(value) => handleInputChange('carNo', value)}
                style={{
                  borderColor: errors.carNo ? 'red' : '',
                }}
              />
              {errors.carNo && (
                <small className="text-red-500">{errors.carNo}</small>
              )}
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-2">
            <div>
              <div className="flex gap-1 w-full flex-col text-start max-w-96">
                <label className="text-stone-700 text-xs font-semibold mt-2">
                  Permit
                </label>
                <StyledFileInput name={'permit'} onChange={handleFileChange} />
                {errors?.permit && (
                  <small className="text-red-500">{errors?.permit}</small>
                )}
              </div>
            </div>
            <div>
              <div className="flex gap-1 w-full flex-col text-start max-w-96">
                <label className="text-stone-700 text-xs font-semibold mt-2">
                  PUC
                </label>
                <StyledFileInput name={'puc'} onChange={handleFileChange} />
                {errors?.puc && (
                  <small className="text-red-500">{errors?.puc}</small>
                )}
              </div>
            </div>
            <div className="flex gap-1 w-full flex-col text-start max-w-96">
              <label className="text-stone-700 text-xs font-semibold mt-2">
                Insurance
              </label>
              <StyledFileInput name={'insurance'} onChange={handleFileChange} />
              {errors?.insurace && (
                <small className="text-red-500">{errors?.insurace}</small>
              )}
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-2 text-start">
            <div>
              <CustomInput
                placeholderValue={'Enter Color'}
                labelValue={'Color'}
                name={`color`}
                value={carDetails?.color || ''}
                onChange={(value) => handleInputChange('color', value)}
                style={{
                  borderColor: errors.color ? 'red' : '',
                }}
              />
              {errors.color && (
                <small className="text-red-500">{errors.color}</small>
              )}
            </div>
            <div className="flex gap-2 mt-2">
              <Select
                labelValue={'Select Brand'}
                selected={selectedBrand}
                onSelect={(value) => {
                  setSelectedBrand(value)
                  setCarDetails((prevDetails) => ({
                    ...prevDetails,
                    variant: '',
                  }))
                }}
                placeholderValue={'Please select brand'}
                options={carModels}
              />
            </div>
            <div className="mt-2">
              <Select
                labelValue={'Select Model'}
                selected={{
                  label: carDetails?.variant,
                  value: carDetails?.variant,
                }}
                onSelect={(value) => handleInputChange('variant', value?.value)}
                placeholderValue={'Please select model'}
                options={carOptions}
              />
              {errors?.variant && (
                <small className="text-red-500">{errors?.variant}</small>
              )}
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-2 text-start">
            <div>
              <DatePicker
                labelValue="Registration  Date"
                selected={carDetails?.registrationDate}
                onChange={(value) =>
                  handleInputChange('registrationDate', value)
                }
                style={{
                  borderColor: errors.registrationDate ? 'red' : '',
                }}
              />
              {errors.registrationDate && (
                <small className="text-red-500">
                  {errors.registrationDate}
                </small>
              )}
            </div>
            <div>
              <DatePicker
                labelValue="Registration Expiry Date"
                selected={carDetails?.registrationExpiryDate}
                onChange={(value) =>
                  handleInputChange('registrationExpiryDate', value)
                }
                style={{
                  borderColor: errors.registrationExpiryDate ? 'red' : '',
                }}
                minDate={minDateCurrentDate}
              />
              {errors.registrationExpiryDate && (
                <small className="text-red-500">
                  {errors.registrationExpiryDate}
                </small>
              )}
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-2 text-start">
            <div>
              <DatePicker
                labelValue="Insurance Expiry Date"
                selected={carDetails?.insuranceExpiryDate || ''}
                onChange={(value) =>
                  handleInputChange('insuranceExpiryDate', value)
                }
                style={{
                  borderColor: errors.insuranceExpiryDate ? 'red' : '',
                }}
                minDate={minDateCurrentDate}
                maxDate={(() => {
                  const maxDate = new Date()
                  maxDate.setFullYear(maxDate.getFullYear() + 1) // Set maxDate to 1 year from today
                  return maxDate.toISOString().split('T')[0] // Return in YYYY-MM-DD format
                })()}
              />
              {errors.insuranceExpiryDate && (
                <small className="text-red-500">
                  {errors.insuranceExpiryDate}
                </small>
              )}
            </div>
            <div>
              <DatePicker
                labelValue="Permit Expiry Date"
                selected={carDetails?.permitExpiryDate}
                onChange={(value) => {
                  handleInputChange('permitExpiryDate', value)
                }}
                minDate={minDateCurrentDate}
                maxDate={(() => {
                  const maxDate = new Date()
                  maxDate.setFullYear(maxDate.getFullYear() + 2) // Set maxDate to 1 year from today
                  return maxDate.toISOString().split('T')[0] // Return in YYYY-MM-DD format
                })()}
              />
              {errors?.permitExpiryDate && (
                <small className="text-red-500">
                  {errors?.permitExpiryDate}
                </small>
              )}
            </div>
            <div>
              <DatePicker
                labelValue="PUC Expiry Date"
                selected={carDetails?.pucExpiryDate}
                onChange={(value) => {
                  handleInputChange('pucExpiryDate', value)
                }}
                minDate={minDateCurrentDate}
                maxDate={(() => {
                  const maxDate = new Date()
                  maxDate.setFullYear(maxDate.getFullYear() + 1) // Set maxDate to 1 year from today
                  return maxDate.toISOString().split('T')[0] // Return in YYYY-MM-DD format
                })()}
              />
              {errors?.pucExpiryDate && (
                <small className="text-red-500">{errors?.pucExpiryDate}</small>
              )}
            </div>
          </div>
        </div>
        <div className="flex gap-2 mt-4">
          <SkyButton label={'Submit'} onClick={handleSubmit} />
          <SkyOutlinedButton label={'Cancel'} onClick={() => navigate(-1)} />
        </div>
      </div>
    </div>
  )
}

export default FleetCabEdit
